(() => {
  const mount = (root) => {
    if (root.dataset.b2bMounted === 'true') return;
    root.dataset.b2bMounted = 'true';
    const optional = root.querySelector('[data-b2b-optional]');
    const fields = {
      label: root.querySelector('[data-b2b-label-select]'),
      quantity: root.querySelector('[data-b2b-quantity-select]'),
      interest: root.querySelector('[data-b2b-interest-select]')
    };
    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-b2b-label], [data-b2b-quantity], [data-b2b-interest]');
      if (!link || !root.contains(link)) return;
      for (const key of Object.keys(fields)) {
        const value = link.dataset[`b2b${key[0].toUpperCase()}${key.slice(1)}`];
        const select = fields[key];
        const option = select && Array.from(select.options).find(item => (item.dataset.b2bValue || item.value) === value);
        if (value && option) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          if (optional) optional.open = true;
        }
      }
    });
    const success = root.querySelector('[role="status"]');
    if (success) success.focus({ preventScroll: true });
  };
  document.querySelectorAll('[data-b2b-root]').forEach(mount);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-b2b-root]').forEach(mount);
  });
})();
